import { render, staticRenderFns } from "./ConfirmDividendDeclaration.vue?vue&type=template&id=cbb20f96&scoped=true"
import script from "./ConfirmDividendDeclaration.vue?vue&type=script&lang=js"
export * from "./ConfirmDividendDeclaration.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDividendDeclaration.vue?vue&type=style&index=0&id=cbb20f96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb20f96",
  null
  
)

export default component.exports